import * as React from "react";
import { CreateOrEditExternalFeed } from "./CreateOrEditExternalFeed";
interface CreateFeedPageProps {
    spaceId: string;
}
export function CreateFeedPage({ spaceId }: CreateFeedPageProps) {
    return <CreateOrEditExternalFeed spaceId={spaceId} create={true}/>;
}
